export default "__VITE_ASSET__4523b5c9__"